/**
 * No scripts for now, posthog has been moved to the analytics package
 */
const DOMThirdPartyScripts = () => {
  return undefined;
};
export default DOMThirdPartyScripts;
